module.exports = __webpack_public_path__ + "static/media/custodio.4b1c8222.png";